module.exports = __webpack_public_path__ + "img/Icon Container (1).83ffd197.png";